import { jsx as _jsx } from "react/jsx-runtime";
import { ArchiveRestore, AlertCircle, AlertTriangle, ArrowRight, ArrowUpDown, Bell, Check, CheckCircle2, ChevronDown, ChevronRight, ChevronUp, Copy, Download, ExternalLink, Eye, EyeOff, FileText, Filter, Home, Inbox, Info, LayoutGrid, List, Loader2, LogOut, Moon, MoreHorizontal, PanelLeftClose, PanelLeftOpen, Pencil, Plug, Plus, Search, Settings, Sun, Trash2, User, UserPlus, X, Package, ClipboardCheck, } from 'lucide-react';
/** All icons available via `<Icon name=…/>`. Keep in sync with assets/README.md. */
export const ICONS = {
    'alert-circle': AlertCircle,
    'alert-triangle': AlertTriangle,
    'archive': ArchiveRestore,
    'arrow-right': ArrowRight,
    'arrow-up-down': ArrowUpDown,
    'bell': Bell,
    'check': Check,
    'check-circle': CheckCircle2,
    'chevron-down': ChevronDown,
    'chevron-right': ChevronRight,
    'chevron-up': ChevronUp,
    'clipboard-check': ClipboardCheck,
    'copy': Copy,
    'download': Download,
    'external-link': ExternalLink,
    'eye': Eye,
    'eye-off': EyeOff,
    'file-text': FileText,
    'filter': Filter,
    'home': Home,
    'inbox': Inbox,
    'info': Info,
    'layout-grid': LayoutGrid,
    'list': List,
    'loader': Loader2,
    'log-out': LogOut,
    'moon': Moon,
    'more-horizontal': MoreHorizontal,
    'package': Package,
    'panel-left-close': PanelLeftClose,
    'panel-left-open': PanelLeftOpen,
    'pencil': Pencil,
    'plug': Plug,
    'plus': Plus,
    'search': Search,
    'settings': Settings,
    'sun': Sun,
    'trash': Trash2,
    'user': User,
    'user-plus': UserPlus,
    'x': X,
};
export function Icon({ name, size = 16, strokeWidth = 1.5, ...rest }) {
    const Cmp = ICONS[name];
    return _jsx(Cmp, { size: size, strokeWidth: strokeWidth, "aria-hidden": "true", ...rest });
}
//# sourceMappingURL=Icon.js.map